$(function(){
    setTimeout(() => {
        $('.box1_title').addClass('showup')
    }, 200);
})

if(window.innerWidth>750){
    var box5T = 3500,box6View=3.5,box6Speed=14000
}else{
    box5T = 2000,box6View=1.3,box6Speed=8000
}

// 获取根元素的字体大小
let rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
var remValue = -3.2 * rootFontSize;

let controller1 = new ScrollMagic.Controller();

let scene2 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box2',
    triggerHook: "onenter",
    duration:0,
})
scene2.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box2_title').addClass('showup')
    if(index<2){
        $('.box2_title').removeClass('showup')
    }
})

let scene1 = new ScrollMagic.Scene({
    offset: remValue,
    triggerElement: '.box1_1',
    triggerHook: "0",
    duration:800,
})
if(window.innerWidth>750){
    scene1.setPin('.box1_1')
    scene1.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>5){
            if(index<85){
                $('.box1_mask').css({transform:`scale(${mapValue(index,5,85,1,3)})`,opacity:`${mapValue(index,5,85,1,0)}`})
            }else{
                $('.box1_mask').css({transform:`scale(3)`,opacity:`0`})
            }
        }else{
            $('.box1_mask').css({transform:`scale(1)`,opacity:`1`})
        }
    })
}

let scene2_1 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box2_1',
    triggerHook: "onenter",
    duration:0,
})
scene2_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box2_1_title').addClass('showup')
    if(index<2){
        $('.box2_1_title').removeClass('showup')
    }
})

let scene3 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box3',
    triggerHook: "onenter",
    duration:0,
})
scene3.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box3_title').addClass('showup')
    if(index<2){
        $('.box3_title').removeClass('showup')
    }
})

let scene4 = new ScrollMagic.Scene({
    offset: -500,
    triggerElement: '.box4',
    triggerHook: "0",
    duration:200,
})
scene4.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100; 
    if(index>5){
        if(index<85){
            $('.box4_pro').css({transform:`scale(${mapValue(index,5,85,50,1)}) translate(${mapValue(index,5,85,1.5,0)}rem,${mapValue(index,5,85,2,0)}rem)`})
            $('.box4_info').removeClass('showup')
        }else{
            $('.box4_pro').css({transform:'scale(1) translate(0,0)'})
            $('.box4_info').addClass('showup')
        }
    }else{
        $('.box4_pro').css({transform:'scale(50) translate(1.5rem,2rem)'})
    }
})

let scene4_1 = new ScrollMagic.Scene({
    offset: remValue,
    triggerElement: '.box4',
    triggerHook: "0",
    duration:2000,
})
if(window.innerWidth>750){
    scene4_1.setPin('.box4')
    scene4_1.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>30){
            $('.box4_items div:nth-child(1)').addClass('showup')
            if(index>50){
                $('.box4_items div:nth-child(2)').addClass('showup')
                if(index>70){
                    $('.box4_items div:nth-child(3)').addClass('showup')
                }else{
                    $('.box4_items div:nth-child(3)').removeClass('showup')
                }
            }else{
                $('.box4_items div:nth-child(2)').removeClass('showup')
            }
        }else{
            $('.box4_items div:nth-child(1)').removeClass('showup')
        }
        for(let i=1;i<39;i++){
            //88
            if(index>i*2){
                $('.box4_img img').hide()
                $(`.box4_img img:nth-child(${i})`).show()
            }
        }
    })
}

let scene5 = new ScrollMagic.Scene({
    offset: -500,
    triggerElement: '.box5',
    triggerHook: "0",
    duration:200,
})
scene5.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100; 
    if(index>5){
        if(index<85){
            $('.box5_pro').css({transform:`scale(${mapValue(index,5,85,50,1)}) translate(${mapValue(index,5,85,1.5,0)}rem,${mapValue(index,5,85,2,0)}rem)`})
            $('.box5_info').removeClass('showup')
        }else{
            $('.box5_pro').css({transform:'scale(1) translate(0,0)'})
            $('.box5_info').addClass('showup')
        }
    }else{
        $('.box5_pro').css({transform:'scale(50) translate(1.5rem,2rem)'})
    }
})

let scene5_1 = new ScrollMagic.Scene({
    offset: remValue,
    triggerElement: '.box5',
    triggerHook: "0",
    duration:box5T,
})
scene5_1.setPin('.box5')
scene5_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    for(let i=1;i<31;i++){
        if(index>i){
            $('.box5_img img').hide()
            $(`.box5_img img:nth-child(${i})`).show()
        }
    }
    for(let i=1;i<33;i++){
        if(index-60>i){
            $('.box5_img2 img').hide()
            $(`.box5_img2 img:nth-child(${i})`).show()
        }
    }
    if(index>30){
        $('.box5_items').addClass('showup')
        if(index>50){
            $('.box5_items').removeClass('showup')
            $('.box5_img2').css({opacity:'1'})
        }else{
            $('.box5_img2').css({opacity:'0'})
        }
    }else{
        $('.box5_items').removeClass('showup')
    }
})

let scene6 = new ScrollMagic.Scene({
    offset: -40,
    triggerElement: '.box6',
    triggerHook: "0",
    duration:600,
})
if(window.innerWidth>750){
    scene6.setPin('.box6')
    scene6.on("progress", function (event) {
        var index=event.progress.toFixed(3) * 100;
        if(index>50){
            $('.box6_left div').css({transform:'translateX(0)'})
            $('.box6_line1').css({width:'100%'})
            $('.box6_text div').addClass('showup')
            $('.box6_text d').addClass('showup')
            $('.box6_tip').addClass('showup')
        }else{
            $('.box6_left div:nth-child(1)').css({transform:'translateX(6.6rem)'})
            $('.box6_left div:nth-child(2)').css({transform:'translateX(-7rem)'})
            $('.box6_line1').css({width:'0%'})
            $('.box6_text div').removeClass('showup')
            $('.box6_text d').removeClass('showup')
            $('.box6_tip').removeClass('showup')
        }
    })
}

let scene6_1 = new ScrollMagic.Scene({
    offset: 150,
    triggerElement: '.box6',
    triggerHook: "onenter",
    duration:0,
})
scene6_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(window.innerWidth>750){
        if(index>2){
            $('.box6_line2').css({width:'100%'})
            $('.box6_text c').addClass('showup')
        }else{
            $('.box6_line2').css({width:'0%'})
            $('.box6_text c').removeClass('showup')
        }
    }else{
        if(index>2){
            $('.box6_left div').css({transform:'translateX(0)'})
            $('.box6_line1').css({width:'100%'})
            $('.box6_line2').css({width:'100%'})
        }else{
            $('.box6_left div:nth-child(1)').css({transform:'translateX(4.8rem)'})
            $('.box6_left div:nth-child(2)').css({transform:'translateX(-4rem)'})
            $('.box6_line1').css({width:'0'})
            $('.box6_line2').css({width:'0'})
        }
    }
})

let scene6_2 = new ScrollMagic.Scene({
    offset: -150,
    triggerElement: '.box6',
    triggerHook: "onenter",
    duration:0,
})
scene6_2.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    $('.box6_title').addClass('showup')
    if(index<2){
        $('.box6_title').removeClass('showup')
    }
})

let scene7 = new ScrollMagic.Scene({
    offset: -800,
    triggerElement: '.box7',
    triggerHook: "0",
    duration:200,
})
scene7.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100; 
    if(index>5){
        if(index<85){
            $('.box7_pro').css({transform:`scale(${mapValue(index,5,85,50,1)}) translate(${mapValue(index,5,85,1,0)}rem,${mapValue(index,5,85,2,0)}rem)`})
            $('.box7_info').removeClass('showup')
        }else{
            $('.box7_pro').css({transform:'scale(1) translate(0,0)'})
            $('.box7_info').addClass('showup')
        }
    }else{
        $('.box7_pro').css({transform:'scale(50) translate(1rem,2rem)'})
    }
})

let scene7_1 = new ScrollMagic.Scene({
    offset: -100,
    triggerElement: '.box7',
    triggerHook: "onenter",
    duration:800,
})
scene7_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(index>10){
        $('.box7_video')[0].play()
        if(index>40){
            $('.box7_video')[1].play()
            $('.box7_video')[0].pause()
            if(index>80){
                $('.box7_video')[2].play()
                $('.box7_video')[1].pause()
                $('.box7_video')[0].pause()
            }
        }
    }
})

let scene8 = new ScrollMagic.Scene({
    offset: -500,
    triggerElement: '.box8',
    triggerHook: "0",
    duration:200,
})
scene8.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100; 
    if(index>5){
        if(index<85){
            $('.box8_pro').css({transform:`scale(${mapValue(index,5,85,50,1)}) translate(${mapValue(index,5,85,1.5,0)}rem,${mapValue(index,5,85,2,0)}rem)`})
            $('.box8_info').removeClass('showup')
        }else{
            $('.box8_pro').css({transform:'scale(1) translate(0,0)'})
            $('.box8_info').addClass('showup')
        }
    }else{
        $('.box8_pro').css({transform:'scale(50) translate(1.5rem,2rem)'})
    }
})

let scene8_1 = new ScrollMagic.Scene({
    offset: remValue,
    triggerElement: '.box8',
    triggerHook: "0",
    duration:1500,
})
scene8_1.setPin('.box8')
scene8_1.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100;
    if(window.innerWidth>750){
        if(index>5){
            $('.box8_items').css({transform:`translateX(${mapValue(index,5,85,0,-56)}rem)`})
            $('.box8_line span').css({width:`${mapValue(index,5,85,10,100)}%`})
            if(index>85){
                $('.box8_items').css({transform:'translateX(-56rem)'})
                $('.box8_line span').css({width:`100%`})
            }
        }else{
            $('.box8_items').css({transform:'translateX(0rem)'})
            $('.box8_line span').css({width:`10%`})
        }
    }else{
        if(index>5){
            $('.box8_items').css({transform:`translateX(${mapValue(index,5,85,0,-80)}%)`})
            $('.box8_line span').css({width:`${mapValue(index,5,85,10,100)}%`})
            if(index>85){
                $('.box8_items').css({transform:'translateX(-80%)'})
                $('.box8_line span').css({width:`100%`})
            }
        }else{
            $('.box8_items').css({transform:'translateX(0%)'})
            $('.box8_line span').css({width:`10%`})
        }
    }
})

let scene9 = new ScrollMagic.Scene({
    offset: -500,
    triggerElement: '.box9',
    triggerHook: "0",
    duration:200,
})
scene9.on("progress", function (event) {
    var index=event.progress.toFixed(3) * 100; 
    if(index>5){
        if(index<85){
            $('.box9_pro').css({transform:`scale(${mapValue(index,5,85,50,1)}) translate(${mapValue(index,5,85,1,0)}rem,${mapValue(index,5,85,2,0)}rem)`})
            $('.box9_info').removeClass('showup')
        }else{
            $('.box9_pro').css({transform:'scale(1) translate(0,0)'})
            $('.box9_info').addClass('showup')
        }
    }else{
        $('.box9_pro').css({transform:'scale(50) translate(1rem,2rem)'})
    }
})

controller1.addScene([scene2,scene1,scene2_1,scene3,scene4,scene4_1,scene5,scene5_1,scene6,scene6_1,scene6_2,scene7,scene7_1,scene8,scene8_1,scene9]); 

$('.pnr_buy').click(function(){ 
    window.open('https://store.oxva.com/products/oxva-xlim-pro-2'); 
})

$('.pnr_spec').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})

$('.pnr_over2').click(function(){
    $('.Mpn_popup').css({height:'0'})
    buyFlag = true
    $('.classic_section2').hide()
    $('.classic_section1').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(1)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(2)').removeClass('color_red')
})


//box9
$('.box9_btn div').click(function(){
    var index = $(this).index()+1
    $('.box9_btn div').removeClass('box9_btnActive')
    $(this).addClass('box9_btnActive')
    $('.box9_icon img').hide()
    $(`.box9_icon img:nth-child(${index})`).show()
})

$('.box3_NColor div').click(function(){
    var index = $(this).index()+1
    $('.box3_OColor div span').css({opacity:0})
    $('.box3_NColor div').removeClass('box3_Nactive')
    $(this).addClass('box3_Nactive')
    box3Swiper.slideTo(index, 300, false);
})

$('.box3_OColor div').click(function(){
    var index = $(this).index()+9
    $('.box3_NColor div').removeClass('box3_Nactive')
    $('.box3_OColor div span').css({opacity:0})
    $(this).children('span').css({opacity:1})
    box3Swiper.slideTo(index, 300, false);
})

$('.box3_icon div').click(function(){
    var index = $(this).index()+1
    // 索引从0开始
    $(".box3_icon div:lt(8)").removeClass('box3_Nactive')
    $('.box3_icon div:gt(7) span').css({opacity:0})
    if(index<9){
        $(this).addClass('box3_Nactive')
    }else{
        $(this).children('span').css({opacity:1})
    }
    box3Swiper.slideTo(index, 300, false);
})

//box3
var box3Swiper = new Swiper('.box3Swiper', {
    loop: true,
    slideToClickedSlide: true,
    effect: 'fade',
    autoplay: {
        delay: 1500,
        // disableOnInteraction: false,
    },
    on:{
        slideChange: function(){
            var index = this.realIndex+1
            // desktop
            $(".box3_icon div:lt(8)").removeClass('box3_Nactive')
            $('.box3_icon div:gt(7) span').css({opacity:0})
            if(index<9){
                $(`.box3_icon div:nth-child(${index})`).addClass('box3_Nactive')
            }else{
                $(`.box3_icon div:nth-child(${index})`).children('span').css({opacity:1})
            }
            // mobile
            if(index<9){
                $('.box3_OColor div span').css({opacity:0})
                $('.box3_NColor div').removeClass('box3_Nactive')
                $(`.box3_NColor div:nth-child(${index})`).addClass('box3_Nactive')
            }else{
                $('.box3_NColor div').removeClass('box3_Nactive')
                $('.box3_OColor div span').css({opacity:0})
                $(`.box3_OColor div:nth-child(${index-8})`).children('span').css({opacity:1})
            }
        },
    }
})

new Swiper('.newH6swiper1', {
    speed:box6Speed,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        //waitForTransition: false,
    },
    slidesPerView :box6View,
    loop:true
})

new Swiper('.newH6swiper2', {
    speed:box6Speed,
    autoplay: {
        delay: 0,
        disableOnInteraction: false,
        reverseDirection: true
        //waitForTransition: false,
    },
    slidesPerView :box6View,
    loop:true
})


new Swiper('.box9_1Swiper', {
    autoplay: {
        delay: wFlag?2000:1500,
        disableOnInteraction: false,
    },
    slideToClickedSlide: true,
    centeredSlides: true,
    slidesPerView:wFlag?5:1.5,
    loop:true
})
if(window.innerWidth>750){
    //box9
    var box9Swiper = new Swiper('.box9Swiper', {
        slidesPerView: 5,
        centeredSlides: true,
        loop: true
    })
    box9Swiper.activeIndex = 7;
    box9Swiper.update()

    //box8
    $('.box8_flag').hover(function(){
        $(this).children('video')[0].currentTime = 0
        $(this).children('video')[0].play()
        $(this).children('video').css({opacity:'1'})
    },function(){
        $(this).children('video')[0].pause()
        $(this).children('video').css({opacity:'0'})
    })


    //box7
    $('.box7_img').hover(function(){ 
        $(this).children('video')[0].currentTime = 0
        $(this).children('video')[0].play()
        $(this).children('video').css({opacity:'1'})
    },function(){
        $(this).children('video')[0].pause()
        $(this).children('video').css({opacity:'0'})
    })


    //box2
    var box2Swiper = new Swiper('.box2Swiper', {
        slidesPerView: 5,
        centeredSlides: true,
        loop:true,
        autoplay: {
            disableOnInteraction: false,
            delay: 1500,
        },
    })

}else{
    //box9
    var box9Swiper = new Swiper('.box9Swiper', {
        slidesPerView: 3,
        centeredSlides: true,
        loop: true
    })
    box9Swiper.activeIndex = 5;
    box9Swiper.update()

    //box8
    $('.box8_flag video')[0].play()
    $('.box8_flag video')[1].play()

    //box7
    $(".box7_video").removeAttr("loop");

    var box2Swiper = new Swiper('.box2Swiper', {
        slidesPerView: 2.8,
        centeredSlides: true,
        loop:true,
        autoplay: {
            disableOnInteraction: false,
            delay: 1500,
        }
    })
}
box2Swiper.activeIndex = 2
box2Swiper.update()

//boxSpecs_btn
$('.boxSpecs_btn').click(function(){
    $('.classic_section1').hide()
    $('.classic_section2').show()
    window.scrollTo(0,0)
    $('.nav_flag .pnr_text:nth-child(2)').addClass('color_red')
    $('.nav_flag .pnr_text:nth-child(1)').removeClass('color_red')
})



$('.box2_1_items div').click(function(){
    var index = $(this).index()+1
    if(index == 1){
        var element = document.querySelector(".box4");
        element.scrollIntoView({block: "start"});
    }else if(index == 2){
        var element = document.querySelector(".box5");
        element.scrollIntoView({block: "start"});
    }else if(index == 3){
        var element = document.querySelector(".box8");
        element.scrollIntoView({block: "start"});
    }else if(index == 4){
        var element = document.querySelector(".box9");
        element.scrollIntoView({block: "start"});
    }
})